module.exports = __webpack_public_path__ + "static/img/2735_phase_function_Paper_Points.1bce2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2735_phase_function_Paper_Points.png
// module id = LASa
// module chunks = 0